import Constants from "../Constants";

export class PatientConstants {

  // patient program rest url
  static PATIENTS_URL = Constants.PATIENT_SERVICE_API_ENDPOINT + 'patients';
  static PATIENT_PROGRAMS_URL = Constants.PATIENT_PROGRAM_API_ENDPOINT + 'patient_programs';
  static PATIENT_PROGRAM_DOCUMENTS_URL = Constants.PATIENT_PROGRAM_API_ENDPOINT + 'documents';
}